import { useState } from 'react';

export default function Registration() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    objetivo: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d59qhqkf78kfudd4jsrg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ nome: '', email: '', telefone: '', objetivo: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="inscricao" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Left - Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-full" style={{ minHeight: '500px' }}>
                <img
                  src="https://public.readdy.ai/ai/img_res/3395340460b97acd6746fed9fd6cd1f7.jpg"
                  alt="Kit Desafio 10 Dias"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute top-6 left-6 flex gap-3">
                <span className="bg-white/90 backdrop-blur-sm text-gray-900 px-4 py-2 rounded-full text-sm font-semibold">
                  E-book Receitas
                </span>
                <span className="bg-white/90 backdrop-blur-sm text-gray-900 px-4 py-2 rounded-full text-sm font-semibold">
                  App Exclusivo
                </span>
                <span className="bg-white/90 backdrop-blur-sm text-gray-900 px-4 py-2 rounded-full text-sm font-semibold">
                  Certificado
                </span>
              </div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="flex flex-col justify-center">
            <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              O Que Está Incluído
            </h2>
            
            <div className="flex flex-wrap gap-3 mb-8">
              <span className="border-2 border-gray-900 text-gray-900 px-5 py-2 rounded-full text-sm font-semibold">
                Tudo Incluído
              </span>
              <span className="text-gray-600 px-5 py-2 text-sm font-medium">
                Sem Taxas Extras
              </span>
              <span className="text-gray-600 px-5 py-2 text-sm font-medium">
                Acesso Vitalício
              </span>
            </div>

            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-8 shadow-2xl">
              <div className="inline-block bg-lime-400 text-gray-900 px-4 py-1 rounded-full text-xs font-bold mb-6">
                BÔNUS
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-2xl font-bold text-white mb-4">
                    Pacote Completo
                  </h3>
                  <ul className="space-y-3 text-white">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-lime-400 text-xl mt-1"></i>
                      <span>Plano alimentar personalizado</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-lime-400 text-xl mt-1"></i>
                      <span>Vídeos de treino em HD</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-lime-400 text-xl mt-1"></i>
                      <span>Grupo VIP no Telegram</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-lime-400 text-xl mt-1"></i>
                      <span>Acompanhamento diário</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-lime-400 text-xl mt-1"></i>
                      <span>Lista de compras semanal</span>
                    </li>
                  </ul>
                </div>
                
                <div className="relative">
                  <div className="w-full h-full rounded-2xl overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=digital%20tablet%20displaying%20fitness%20app%20interface%20with%20meal%20plans%20and%20workout%20videos%20on%20modern%20desk%20with%20healthy%20food%20and%20dumbbells%20professional%20lifestyle%20photography%20clean%20aesthetic%20natural%20lighting&width=600&height=600&seq=digital-preview-001&orientation=squarish"
                      alt="Preview Digital"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Registration Form */}
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl p-10">
            <div className="text-center mb-10">
              <h3 className="text-4xl font-bold text-gray-900 mb-4">
                Garanta Sua Vaga Agora
              </h3>
              <p className="text-lg text-gray-600">
                Preencha o formulário abaixo e comece sua transformação
              </p>
            </div>

            <form id="registration-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="nome" className="block text-sm font-semibold text-gray-700 mb-2">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  required
                  value={formData.nome}
                  onChange={handleChange}
                  className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-teal-500 focus:outline-none transition-colors text-base"
                  placeholder="Seu nome completo"
                />
              </div>

              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                  E-mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-teal-500 focus:outline-none transition-colors text-base"
                  placeholder="seu@email.com"
                />
              </div>

              <div>
                <label htmlFor="telefone" className="block text-sm font-semibold text-gray-700 mb-2">
                  Telefone/WhatsApp *
                </label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  required
                  value={formData.telefone}
                  onChange={handleChange}
                  className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-teal-500 focus:outline-none transition-colors text-base"
                  placeholder="(00) 00000-0000"
                />
              </div>

              <div>
                <label htmlFor="objetivo" className="block text-sm font-semibold text-gray-700 mb-2">
                  Qual seu principal objetivo? *
                </label>
                <select
                  id="objetivo"
                  name="objetivo"
                  required
                  value={formData.objetivo}
                  onChange={handleChange}
                  className="w-full px-5 py-4 border-2 border-gray-200 rounded-xl focus:border-teal-500 focus:outline-none transition-colors text-base cursor-pointer"
                >
                  <option value="">Selecione uma opção</option>
                  <option value="Perder peso">Perder peso</option>
                  <option value="Ganhar massa muscular">Ganhar massa muscular</option>
                  <option value="Melhorar saúde">Melhorar saúde</option>
                  <option value="Aumentar disposição">Aumentar disposição</option>
                  <option value="Outro">Outro</option>
                </select>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border-2 border-green-500 text-green-800 px-6 py-4 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-checkbox-circle-fill text-2xl"></i>
                    <span className="font-semibold">Inscrição realizada com sucesso! Em breve entraremos em contato.</span>
                  </div>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border-2 border-red-500 text-red-800 px-6 py-4 rounded-xl">
                  <div className="flex items-center gap-3">
                    <i className="ri-error-warning-fill text-2xl"></i>
                    <span className="font-semibold">Erro ao enviar. Tente novamente.</span>
                  </div>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold text-lg px-8 py-5 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? (
                  <span className="flex items-center justify-center gap-3">
                    <i className="ri-loader-4-line animate-spin text-xl"></i>
                    Enviando...
                  </span>
                ) : (
                  <span className="flex items-center justify-center gap-3">
                    <i className="ri-send-plane-fill text-xl"></i>
                    QUERO PARTICIPAR DO DESAFIO
                  </span>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
